import { Component, Input } from '@angular/core';
import { Exam } from 'src/app/models/exam.model';
@Component({
  selector: 'app-exam-result-list',
  templateUrl: './exam-result-list.component.html',
  styleUrls: ['./exam-result-list.component.scss'],
  standalone: false
})
export class ExamResultListComponent {

  @Input() exam!: Exam;
  expandedQuestions: { [id: number]: boolean } = {};

  constructor() {}

  ngOnInit(): void {
  }

  toggleExpand(questionId: number) {
    this.expandedQuestions[questionId] = !this.expandedQuestions[questionId];
  }
}
